import { 
    SET_WIN_SERVICES_LIST, 
    SET_WIN_SERVICE_STATUS,
    SET_REPORT_QUEUE_RUNNING,
    SET_REPORT_QUEUE_FULL
} from '../types';

const INITIAL_STATE = {
    winServices: {
        list: [],
        status: {}
    },
    runningReports: [],
    fullReportQueue: []
}

export const ServiceStatus = {
    Stopped: "Stopped",
    StartPending: "StartPending",
    StopPending: "StopPending",
    Running: "Running",
    ContinuePending: "ContinuePending",
    PausePending: "PausePending",
    Paused: "Paused"
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_WIN_SERVICES_LIST:
            return { ...state, winServices: { ...state.winServices, list: action.payload } };
        case SET_WIN_SERVICE_STATUS:
            return { ...state, winServices: { ...state.winServices, status: { ...state.winServices.status, [action.name]: action.payload } } };
        case SET_REPORT_QUEUE_RUNNING:
            return { ...state, runningReports: action.payload }
        case SET_REPORT_QUEUE_FULL:
            return { ...state, fullReportQueue: action.payload }
        default:
            return state;
    }
}